import { Button, useTheme } from "@mui/material";
import React from "react";
import MinimizedTooltip from "../../tooltip/MinimizedTooltip";
import { RotateCcw } from "lucide-react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  resetFilters: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0.5, 1),
    cursor: "pointer",
  },
}));

interface ResetFiltersButtonProps {
  onClick: () => void;
  disabled: boolean;
  className?: string;
  size?: number;
  tooltipPlacement?: "top" | "bottom";
}

const ResetFiltersButton = (props: ResetFiltersButtonProps) => {
  const {
    onClick,
    disabled,
    className,
    size,
    tooltipPlacement = "top",
  } = props;
  const theme = useTheme();
  const s = useStyles();

  return (
    <MinimizedTooltip
      title={disabled ? "No filters to reset" : "Reset filters"}
      placement={tooltipPlacement}
      opacity={0.8}
      isExerciseLibrary
    >
      <Button
        className={clsx(s.resetFilters, className)}
        disabled={disabled}
        onClick={() => {
          onClick?.();
        }}
      >
        <RotateCcw
          color={disabled ? theme.palette.divider : theme.palette.primary.main}
          size={size}
        />
      </Button>
    </MinimizedTooltip>
  );
};

export default ResetFiltersButton;
